import { createSlice } from '@reduxjs/toolkit';
const initialPluginState = {
  starterPrompts: {
    emptyStateStarterPrompts: [],
    // These are primary actions that are shown in the copilot empty thread state.
    interactionStarterPrompts: {} // These are secondary actions mapped by system message ID
  }
};
export const pluginSlice = createSlice({
  name: 'plugin',
  initialState: initialPluginState,
  reducers: {
    setStarterPrompts: (state, action) => {
      if (action.payload.emptyStateStarterPrompts !== undefined) {
        state.starterPrompts.emptyStateStarterPrompts = action.payload.emptyStateStarterPrompts;
      }
    },
    setInteractionStarterPrompts: (state, action) => {
      state.starterPrompts.interactionStarterPrompts[action.payload.systemMessageId] = action.payload.actions;
    },
    clearInteractionStarterPromptsForSystemMessage: (state, action) => {
      delete state.starterPrompts.interactionStarterPrompts[action.payload.systemMessageId];
    }
  }
});
export const {
  setStarterPrompts,
  setInteractionStarterPrompts,
  clearInteractionStarterPromptsForSystemMessage
} = pluginSlice.actions;
export default pluginSlice.reducer;